import { useCallback, useEffect, useState } from "react";
import { EmployeeService } from "../services/EmployeeService";

export const useHookEmployee = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('name');
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await EmployeeService.get({search, sort, perPage, page, });
            setData(res.data.data);
            setMeta(res.data.meta);
        }catch(err){
            setError(err);
            throw err;
        }finally{
            setLoading(false);
        }
    }, [search, sort, page, perPage]);

    useEffect(()=>{
        getData();
    },[getData, search, sort, page, perPage]);

    return {
        data,
        meta,
        loading,
        error,

        search,
        setSearch,

        sort,
        setSort,

        perPage,
        setPerPage,

        page,
        setPage,

        refreshData: () => getData()
    }
}